import { Box, BoxProps, useTheme } from "@mui/material";
import { ReactNode } from "react";
import RouteHeader from "./DashboardPageHeader";

interface Tab {
	tabRoute: string;
	label?: string;
}

export interface RouteProps {
	pageName: string;
	childTabs?: Tab[];
	defaultTab?: string;
	alerts?: ReactNode[];
}

export default function RouteLayout({ children, alerts, maxWidth, sx, ...routeProps }: RouteProps & BoxProps) {
	const theme = useTheme();
	return (
		<>
			<RouteHeader {...routeProps} />
			{alerts}
			<Box
				sx={{
					bgcolor: "white",
					borderRadius: 1,
					p: { xs: 2, sm: 4 },
					mx: 1,
					mt: 1,
					mb: 12,
					width: `calc(100% - ${theme.spacing(1 * 2)})`,
					[theme.breakpoints.up("xl")]: {
						mx: 20,
						mt: 6,
						width: `calc(100% - ${theme.spacing(20 * 2)})`,
					},
					[theme.breakpoints.up("lg")]: {
						mx: 10,
						mt: 6,
						width: `calc(100% - ${theme.spacing(10 * 2)})`,
					},
					[theme.breakpoints.up("md")]: {
						mx: 6,
						mt: 6,
						width: `calc(100% - ${theme.spacing(6 * 2)})`,
					},
				}}
			>
				<Box component="main" maxWidth={maxWidth ?? "sm"} sx={sx} data-testid="dashboard-content">
					{children}
				</Box>
			</Box>
		</>
	);
}
